<template>
  <div class="header-container">
    <div :class="['tips', {hide: showCloseStatus}]">
      {{ $t('navList.tips') }}
      <img src="./images/close.png" class="close" @click="close">
    </div>
    <div class="header">
      <img class="logo" src="./images/logo.png"  @click="()=>router.push({ path: '/index' })"/>
      <div class="nav">
        <div
          v-for="(list, eq) in navList"
          :key="eq"
          :class="['list', { active: navListIndex === eq }]"
          @click="changeNav(list, eq, 0)">
          {{ list.name }}
          <img src="./images/arrow.svg" class="arrow" alt="arrow" v-if="eq === 2" />
          <div v-if="eq === 2" class="children">
            <div :class="['item', { itemActive: navListChildrenIndex === ind }]" v-for="(item, ind) in list.children" :key="ind" @click.stop.prevent="changeNav(item, ind, 1)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="contact" @click="changeNav({ path: '/contact' }, -1)">
        {{ $t('navList.contact') }}
      </div>
      <img class="language" @click="changeLocale" src="./images/language.svg" alt="language">
    </div>
  </div>
</template>

<script setup name="navHeader">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

const navListIndex = ref(0)
const navListChildrenIndex = ref(-1)
const navList = ref([
  { name: t('navList.home'), path: "/index" },
  { name: t('navList.compare'), path: "/cooperation" },
  { name: t('navList.intro'), path: "/introduce", children: [
   { name: t('navList.ntn_fa'), path: "/introduce" },
   // { name: t('navList.ntn'), path: "/NTN" },
   { name: t('navList.develop'), path: "/develop" },
  ]},
 // { name: t('navList.info'), path: "/info" },
  { name: t('navList.aboutUs'), path: "/about" },
])

const changeLocale = () => {
  locale.value = locale.value === 'zh' ? 'en' : 'zh'
  navList.value = [
    { name: t('navList.home'), path: "/index" },
    { name: t('navList.compare'), path: "/cooperation" },
    { name: t('navList.intro'), path: "/introduce", children: [
     { name: t('navList.ntn_fa'), path: "/introduce" },
    //  { name: t('navList.ntn'), path: "/NTN" },
     { name: t('navList.develop'), path: "/develop" },
    ]},
   // { name: t('navList.info'), path: "/info" },
    { name: t('navList.aboutUs'), path: "/about" },
  ]
}

const changeNav = (data, index, type) => {
  if (type === 0) {
    navListIndex.value = index
    navListChildrenIndex.value = -1
  } else {
    navListIndex.value = 2
    navListChildrenIndex.value = index
  }
  router.push(data.path)
}

const showCloseStatus = ref(false)
const close = () => {
  showCloseStatus.value = true
}

watch(route, (val) => {
  if (val.fullPath === `/contact`) return navListIndex.value = -1
  navList.value.forEach((item, index) => {
    if (val.fullPath === '/introduce') {
      navListIndex.value = 2
      navListChildrenIndex.value = 0
      return
    }
    if (val.fullPath === '/NTN') {
      navListIndex.value = 2
      navListChildrenIndex.value = 1
      return
    }
    if (val.fullPath === '/develop') {
      navListIndex.value = 2
      navListChildrenIndex.value = 2
      return
    }
    if (item.path === `${val.fullPath}`) navListIndex.value = index
  })
})
</script>

<style lang="less" scoped>
.header-container {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 10;
}
.tips {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  width: 100%;
  height: 40px;
  letter-spacing: 2px;
  transition: height .3s ease;
  background: linear-gradient(to right, #5470fe, #fd66c5);
  position: relative;
  &.hide {
    height: 0;
  }
  .close {
    cursor: pointer;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 0;
    right: 30px;
    bottom: 0;
    margin: auto 0;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  min-width: 1280px;
  margin: 0 auto;
  background: #fff;
  .logo {
    width: 140px;
    padding-top: 10px;
  }
  .nav {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    .list {
      color: #333;
      font-size: 16px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      margin: 0 0 0 60px;
      border-bottom: 2px solid transparent;
      position: relative;
      &.active {
        color: #2e69ff;
        font-weight: bold;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background: #2e69ff;
          position: absolute;
          left: 0;
          bottom: 5px;
        }
      }
      &:hover {
        color: #2e69ff;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background: #2e69ff;
          position: absolute;
          left: 0;
          bottom: 5px;
        }
        .arrow {
          transform: rotate(0deg);
        }
        .children {
          display: block;
        }
      }
      .arrow {
        width: 12px;
        margin: 0 0 0 5px;
        transform: rotate(180deg);
        transition: all 0.3s ease;
      }
      .children {
        display: none;
        min-width: 140px;
        //height: 120px;
        border-radius: 6px;
        box-shadow: 0 0 10px #ccc;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 55px;
        //margin: 0 0 0 -70px;
        transform: translateX(-50%);
        transition: all 0.3s ease;
        // &::before {
        //   content: "";
        //   position: absolute;
        //   top: -10px;
        //   left: 0;
        //   right: 0;
        //   margin: 0 auto;
        //   transform: rotate(180deg);
        //   width: 0;
        //   height: 0;
        //   border: 5px solid transparent;
        //   border-top-color: #2e69ff;
        // }
      }
      .item {
        color: #666;
        font-size: 13px;
        font-weight: normal;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0 20px;
        white-space: nowrap;
        &.itemActive {
          color: #2e69ff;
        }
      }
    }
  }
  .contact {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    width: 100px;
    height: 36px;
    margin: 0 0 0 50px;
    border-radius: 4px;
    background: #2e69ff;
  }
  .language {
    cursor: pointer;
    width: 24px;
    margin: 0 0 0 30px;
    padding-right: 40px;
  }
}
</style>
